var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPowerPlugOutlineIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 18",
    id: "svg4",
    width: 12,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 10,4 V 0 H 8 V 4 H 4 V 0 H 2 V 4 C 1,4 0,5 0,6 v 5.5 L 3.5,15 v 3 h 5 V 15 L 12,11.5 V 6 C 12,5 11,4 10,4 M 10,10.67 7.09,13.59 6.67,14 H 5.33 L 4.92,13.59 2,10.67 V 6.09 C 2,6.06 2.06,6 2.09,6 H 9.92 C 9.95,6 10,6.06 10,6.09 Z",
    id: "path2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPowerPlugOutlineIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/power-plug-outline-icon.be45be4f3d088bf21b40f9e0627a2285.svg";